import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function serializationError(message) {
  throw SerializationException().h1o(message.toString());
}
//region block: exports
export {
  serializationError as serializationError3bsuwdsvfqinr,
};
//endregion

//# sourceMappingURL=Errors.mjs.map
